export default {
    inject: ['$validator'],
    props: {
        required: {default: false},
        label: {default: 'label'},
        placeholder: {default: false},
        scope: {default: 'all'},
        restrictions: {default: null},
    },
    mounted(){
      //console.log(this.scope)
    },
    data: () => ({
        focused: false,
        value: ''
    }),
    computed: {
        active() {
            return this.value !== ''
        }
    },
}